import { render, staticRenderFns } from "./IncubatorType.vue?vue&type=template&id=2a2089b8&scoped=true"
import script from "./IncubatorType.vue?vue&type=script&lang=js"
export * from "./IncubatorType.vue?vue&type=script&lang=js"
import style0 from "./IncubatorType.vue?vue&type=style&index=0&id=2a2089b8&prod&scoped=true&lang=css"
import style1 from "./IncubatorType.vue?vue&type=style&index=1&id=2a2089b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2089b8",
  null
  
)

export default component.exports